import { FieldTypes } from '../../../constants'
import { addCondition, createCheckboxField } from '../../../fields/utils'
import { CheckboxField, FieldMap, FormElement } from '../../../types/forms/fields'
import { FieldEncounterSection } from '../types/encounter'

export const educationField: FieldMap = {
  name: 'Education',
  children: {
    patientCounseling: {
      name: 'Patient Counseling',
      children: {
        safeSexPractices: createCheckboxField('Safe Sex Practices'),
        sexualEducation: createCheckboxField('Sexual Education'),
        gardasil: createCheckboxField('Gardasil'),
        emergencyContraception: createCheckboxField('Emergency Contraception'),
        contraception: createCheckboxField('Contraception'),
        adequateWaterIntake: createCheckboxField('Adequate Water Intake'),
        personalHygiene: createCheckboxField('Personal Hygiene'),
        medications: createCheckboxField('Medications'),
        infectiousDiseases: createCheckboxField('Infectious Diseases'),
        papGuidelines: createCheckboxField('PAP Guidelines'),
        dietExerciseFolicAcid: createCheckboxField('Diet, Exercise, Folic Acid Supplements'),
        calciumSupplements: createCheckboxField('Calcium Supplements'),
        immunizations: createCheckboxField('Immunizations'),
        dentalExam: createCheckboxField('Recommended Dental Exam'),
        mammography: createCheckboxField('Mammography'),
      },
    },
    over50years: {
      name: 'Over 50 years old',
      children: {
        reportPostmenopausalBleeding: createCheckboxField('Report Postmenopausal Bleeding'),
        cholesterol: createCheckboxField('Cholesterol'),
        hormoneReplacement: createCheckboxField('Hormone Replacement'),
        colonCancerScreening: createCheckboxField('Colon Cancer Screening'),
        hepatitisB: createCheckboxField('Hepatitis B'),
        boneDensity: createCheckboxField('Bone Density'),
        coatedAsa: createCheckboxField('Coated ASA: 325mg/d 81 mg/d'),
        immunizationsPnemococcal: createCheckboxField('Immunizations: pnemococcal'),
      },
    },
  },
}

export const hasEducationField: CheckboxField = {
  type: FieldTypes.CHECKBOX,
  placeholder: 'Education',
  size: 'lg',
}

export const getEducationSection: (optional: boolean) => FieldEncounterSection = optional => {
  const children: Record<string, FormElement> = {}
  if (optional) {
    children.hasEducation = hasEducationField
    children.education = addCondition(educationField, v => !!v?.hasEducation)
  } else {
    children.education = educationField
  }
  return { type: 'field', field: { name: 'Education', children } }
}
